import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../models/RootState';
import './SBMarketsPage.scss'
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import { LimitDto, MarketGroup } from '../../models/EventData';
import { ExpandMore } from '@mui/icons-material';
import { addExchangeBet } from '../../store/exchBetSlip/exchBetSlipAction';
import { BsData } from '../../models/ExchBetSlip';
import SBOddsGrid from './SBOddsGrid';
import { toast } from 'react-toastify';
import SBBetSlip from '../SBBetSlip/SBBetSlip';
import { OneClickBettingLoader } from '../OneClickBetting/OneClickLoader';

type StoreProps = {
    eventInfo: any;
    bets: BsData[];
    // limits: LimitDto | undefined;
    addExchangeBet: (data: BsData) => void;
    isOneClickBettingEnabled: boolean;
    bettingInprogress: boolean;
};

type OddsInfoMsg = {
    launch: boolean;
    oddsType: string;
    eventTypeID: string;
};

const marketEnableStatus = ["active", "open"];
const marketDisableStatus = ["deactivated", "cancelled", "settled"];
const eventEnableStatus = ["in_play", "upcoming"];


const SBMarketsView: React.FC<StoreProps> = (props) => {
    const {
        eventInfo,
        bets,
        addExchangeBet,
        isOneClickBettingEnabled,
        bettingInprogress
    } = props;
    const [displayMarketGroups, setDisplayMarketGroups] = useState<MarketGroup[] | any>();
    const [openMarket, setOpenMarket] = useState([""]);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedbet, setSelectedbet] = useState<string>("");

    const disabledStatus = [
        'deactivated',
        'suspended',
        'closed',
        'suspended-manually',
    ];
    const [filterData, setFilterData] = useState("");
    const [selectedRow, setSelectedRow] = useState<string>('');
    const [infoDilalog, setInfoDialog] = useState<OddsInfoMsg>({
        launch: false,
        oddsType: "",
        eventTypeID: "",
    });

    const setBetData = (data: any, status: any) => {
        if (disabledStatus.includes(status.toLowerCase())) {
            setSelectedbet("");
            toast.error(`${status}`);
        } else {
            addExchangeBet(data);
        }
    };

    const handleChange = (panel: string) => {
        let index = openMarket?.indexOf(panel);
        if (index > -1) {
            openMarket?.splice(index, 1);
            setOpenMarket([...openMarket]);
        } else {
            setOpenMarket((preState: any) => [...preState, panel]);
        }
    };

    useEffect(() => {
        if (bets && bets.length > 0) {
            setSelectedbet(
                bets[0]?.marketId + bets[0]?.runnerId + bets[0]?.runnerName
            );
            setIsOpen(bets.length > 0);
        } else {
            setSelectedbet("");
        }
    }, [bets]);


    useEffect(() => {
        if (eventInfo) {
            getAndSetMarkets(eventInfo?.markets?.premiumMarkets);
        } else {
            getAndSetMarkets([]);
        }
    }, [eventInfo]);

    const getAndSetMarkets = async (data: any) => {
        let newData: any = [];
        const marketDisableStatus = ["deactivated", "cancelled", "settled"];

        data?.reduce((oldV: any, newV: any) => {
            // show marketname in same order
            let index = oldV.findIndex((item: any) => item.marketName === newV.marketName);

            if (oldV.length && index !== -1) {
                let mrFound = false;
                for (let mr of oldV[index].completeMarket) {
                    if (mr.marketId === newV.marketId) {
                        mr = newV;
                        mrFound = true;
                    }
                }
                if (!mrFound) {
                    oldV[index] = {
                        ...oldV[index],
                        completeMarket: [...oldV[index].completeMarket, newV],
                    };
                }
            } else {
                // If a new market comes, it will be added to it.
                oldV.push({ marketName: newV.marketName, completeMarket: [newV] });
            }
            // return array.
            return oldV;
        }, newData);

        // sorting for runnername
        for (let i = 0; i < newData.length; i++) {
            newData[i].completeMarket.sort((a: any, b: any) => {
                let x = a.marketId;
                let y = b.marketId;
                if (x < y) {
                    return -1;
                }
                if (x > y) {
                    return 1;
                }
                return 0;
            });
        }

        // sorting based on market name
        if (newData?.length) {
            let data = newData
                .filter(
                    (item: any) =>
                        item.marketName === "1x2" ||
                        item.marketName.toLowerCase().startsWith("winner") ||
                        item.marketName === "Handicap" ||
                        item.marketName === "Total"
                )
                .sort((a: any, b: any) => {
                    let oldV = a.marketName.toLowerCase().startsWith("winner")
                        ? "1x2"
                        : a.marketName.toLowerCase();
                    let newV = b.marketName.toLowerCase().startsWith("winner")
                        ? "1x2"
                        : b.marketName.toLowerCase();
                    if (oldV < newV) return -1;
                    if (oldV > newV) return 1;
                    return 0;
                });

            let finalData = data.concat(newData);
            let temp: any = [];
            finalData.map((i: any, idx: any) => {
                i.completeMarket.map((j: any) => {
                    if (!marketDisableStatus.includes(j?.status?.toLowerCase())) {
                        temp.push(i);
                    }
                    return { ...j, runners: [...j.runners].sort((a, b) => a.runnerId - b.runnerId) };
                });
            });

            let temp1 = new Set(temp);
            setDisplayMarketGroups(Array.from(temp1));
        }

        if (eventInfo?.markets?.premiumMarkets?.length === 0) setDisplayMarketGroups([]);
    };

    return (
        <>
            {/* One-Click Betting Loader */}
            { isOneClickBettingEnabled && bettingInprogress && (
                <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[9999]">
                    <OneClickBettingLoader />
                </div>
            )}

            <div className="sport-radar-ctn">
                {!["closed"].includes(eventInfo?.status?.toLocaleLowerCase()) ?
                    displayMarketGroups &&
                        displayMarketGroups.length > 0 ? (
                        <>
                            <div className="accordion-section sportRadar">
                                {displayMarketGroups && displayMarketGroups.length > 0
                                    ? displayMarketGroups
                                        .filter(
                                            (i: any) =>
                                                i.marketName.includes(filterData) ||
                                                i.marketName.includes(filterData.toLowerCase())
                                        )
                                        .map((marketGroup: any, index: any) => {
                                            return (
                                                <Accordion
                                                    expanded={!openMarket?.includes(
                                                        marketGroup?.marketName
                                                    )}
                                                    onChange={() => {
                                                        handleChange(marketGroup?.marketName);
                                                    }}
                                                    key={index}
                                                    className="market-according"
                                                >
                                                    <AccordionSummary
                                                        expandIcon={<ExpandMore />}
                                                        aria-controls="panel1bh-content"
                                                        id="panel1bh-header"
                                                        className="market-according-accordion-summary"
                                                    >
                                                        <Typography
                                                            sx={{ flexShrink: 0 }}
                                                            className="market-name"
                                                        >
                                                            {marketGroup?.marketName.length > 50
                                                                ? marketGroup?.marketName.slice(0, 50) +
                                                                ".."
                                                                : marketGroup?.marketName}
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails className="accordion-detail-section">
                                                        <Grid
                                                            container
                                                            spacing={2}
                                                            className="sport-radar-MuiGrid-root"
                                                        >
                                                            {marketGroup?.completeMarket?.map(
                                                                (market: any, idx: any) => {
                                                                    return (
                                                                        <>
                                                                            {marketDisableStatus.includes(
                                                                                market?.status?.toLowerCase()
                                                                            ) ? null : (
                                                                                <>

                                                                                    {market?.runners?.length >
                                                                                        0 &&
                                                                                        market?.status !== "" ? (
                                                                                        market?.runners?.map(
                                                                                            (d: any, idx: any) => {
                                                                                                return (
                                                                                                    <>
                                                                                                        {marketEnableStatus.includes(
                                                                                                            d?.status?.toLowerCase()
                                                                                                        ) &&
                                                                                                            d?.backPrices
                                                                                                                ?.length > 0 &&
                                                                                                            eventEnableStatus.includes(
                                                                                                                eventInfo?.status?.toLowerCase()
                                                                                                            ) &&
                                                                                                            marketEnableStatus.includes(
                                                                                                                market?.status?.toLowerCase()
                                                                                                            ) ? (
                                                                                                            <>
                                                                                                                <Grid
                                                                                                                    item
                                                                                                                    xs={6}
                                                                                                                    md={6}
                                                                                                                    key={idx.toString()}
                                                                                                                    onClick={() => {
                                                                                                                        setBetData({
                                                                                                                            eventId: eventInfo?.providerName?.toLocaleLowerCase() === "sportradar" ?
                                                                                                                                eventInfo.eventId
                                                                                                                                : eventInfo?.markets?.premiumEventId,
                                                                                                                            eventName: eventInfo?.eventName,
                                                                                                                            competitionId: eventInfo.competitionId,
                                                                                                                            marketName: market?.marketName,
                                                                                                                            marketId: market?.marketId,
                                                                                                                            marketType: market?.marketType,
                                                                                                                            betType: "BACK",
                                                                                                                            oddValue: d?.backPrices[0]?.price,
                                                                                                                            runnerName: d?.runnerName,
                                                                                                                            runnerId: d?.runnerId,
                                                                                                                            sessionOutcome: 0,
                                                                                                                            stakeAmount: 0,
                                                                                                                            maxLimit: market?.limits?.maxBetValue
                                                                                                                                ? market?.limits?.maxBetValue
                                                                                                                                : 0,
                                                                                                                            minLimit: market?.limits?.minBetValue
                                                                                                                                ? market?.limits?.minBetValue
                                                                                                                                : 0,
                                                                                                                            sportId: eventInfo?.providerName?.toLocaleLowerCase() === "sportradar" ?
                                                                                                                                eventInfo?.sportId
                                                                                                                                : eventInfo?.markets?.premiumSportId,
                                                                                                                            provider: "SportRadar",
                                                                                                                            origin: "SPORTSBOOK",
                                                                                                                        }, market?.status);
                                                                                                                    }}
                                                                                                                    className="grid1"
                                                                                                                >
                                                                                                                    <SBOddsGrid
                                                                                                                        data={d}
                                                                                                                        marketId={
                                                                                                                            market?.marketId
                                                                                                                        }
                                                                                                                        selectedbet={
                                                                                                                            selectedbet
                                                                                                                        }
                                                                                                                        mainValue={
                                                                                                                            d
                                                                                                                                ?.backPrices[0]
                                                                                                                                .price
                                                                                                                        }
                                                                                                                    />
                                                                                                                </Grid>
                                                                                                            </>
                                                                                                        ) : (
                                                                                                            <Grid
                                                                                                                item
                                                                                                                xs={6}
                                                                                                                md={6}
                                                                                                                key={`idx-${d?.runnerId}`}
                                                                                                                className="grid1"
                                                                                                            >
                                                                                                                <div className="lock-section"
                                                                                                                >
                                                                                                                    -
                                                                                                                </div>
                                                                                                            </Grid>
                                                                                                        )}
                                                                                                    </>
                                                                                                );
                                                                                            }
                                                                                        )
                                                                                    ) : (
                                                                                        <></>
                                                                                    )}

                                                                                </>
                                                                            )}
                                                                        </>
                                                                    );
                                                                }
                                                            )}
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            );
                                        })
                                    : null}
                                {(displayMarketGroups &&
                                    displayMarketGroups.length == 0) ||
                                    (displayMarketGroups &&
                                        displayMarketGroups.length > 0 &&
                                        displayMarketGroups.filter(
                                            (i: any) =>
                                                i.marketName.includes(filterData) ||
                                                i.marketName.includes(filterData.toLowerCase())
                                        ).length == 0) ? (
                                    <div className="no-markets-available">
                                        No markets available
                                    </div>
                                ) : null}
                            </div>
                        </>
                    ) : (
                        <div className="no-premium-markets">No premium markets</div>
                    ) : <div className="no-premium-markets">Premium markets closed</div>
                }
            </div>

            {!isOneClickBettingEnabled && bets?.length > 0 &&
                <SBBetSlip openBetSlip={isOpen} setOpenBetSlip={setIsOpen} />}
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        bets: state.exchBetSlip.bets,
        eventInfo: state.exchangeSports.eventInfo,
        isOneClickBettingEnabled: state.exchBetSlip.isOneClickBettingEnabled,
        bettingInprogress: state.exchBetSlip.bettingInprogress,
    };
};

const mapDispatchToProps = (dispatch: Function) => {
    return {
        addExchangeBet: (data: BsData) => dispatch(addExchangeBet(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SBMarketsView);
